import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e22cb30"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.modalvisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalvisible) = $event)),
      title: _ctx.title,
      wrapClassName: 'iframemodal',
      getContainer: _ctx.getContainer,
      footer: null,
      onCancel: _ctx.handleOk,
      onOk: _ctx.handleOk,
      width: _ctx.width
    }, {
      default: _withCtx(() => [
        _createElementVNode("iframe", {
          src: _ctx.modalsrc,
          frameborder: "0"
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["visible", "title", "getContainer", "onCancel", "onOk", "width"])
  ]))
}